import { z } from 'zod';
export const dischargeSummaryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        condition: z.array(z.string()).min(1, 'Please select at least one'),
        goalsStatus: z.string().min(1, 'required'),
        servicesProvided: z.array(z.string()).min(1, 'Please select at least one'),
        careSummary: z.string().min(1, 'required'),
        conditionOfDischarge: z.string().min(1, 'required'),
        dischargeDisposition: z.array(z.string()).min(1, 'Please select at least one'),
        dischargeInstructions: z.string().min(1, 'required'),
        verbalizedUnderstanding: z.string().min(1, 'required'),
        otherNotes: z.array(z.string()).optional(),
    }),
});
